import DatePicker from '../components_v/v-date-range-v1'
import { defaultFun } from '../utils'
import { DATE_RANGE_V1 } from '../type_name'
import commonMixins from './commonMixins'
export default {
    name: DATE_RANGE_V1,
    mixins: [ commonMixins ],
    render(h) {
        const {
                         // eslint-disable-next-line 
              slots,scopedSlots,
             key,
             input = defaultFun,
             change = defaultFun,
             ...params 
            } = this.field
            params.locale = params.locale || "zh-cn"
            if (params.attach === undefined) {
                params.attach = true
            }
        return h(DatePicker, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            props: {
                ...params,
                value: this.my_value
            },
            on: {
                input:(data) => {
                    const start_key = params.start_key
                    const end_key = params.end_key
                    this.my_value[start_key] = data[0]
                    this.my_value[end_key] = data[1]
                    input(data)
                },
                change: (data) => {
                    change(data)
                }
            }
        })
    }
}